import { validationTypes } from "../../components/forms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../data/formFieldType";


const forgotPasswordData = {
    name: "Forgot Password From",
    initialState: {EmailAddress: "" },
    section: [
        {
            sectionId: 'basicDetailSection',
            title: "Basic User Details",
            row: {},
            style: {
                sectionStyle: "",
            },
            wrapperTemplate: <div className=" row"></div>,
            fields: [
             
                {
                    id: "EmailAddress",
                    label: "Email Address",
                    Field_Name: "email address",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "psEmailAddress",
                    fieldSetting: {
                        placeholder: "Please enter email address",
                        allowSpace: false,
                        isDisable: false
                    },
                    validation: [{ type: validationTypes.REQUIRE }, { type: validationTypes.EMAIL }],
                    style: {
                        containerCss: "col-md-12 forgot-password-input mb-3"
                    }
                },
            ],
        }
    ]
};

export default forgotPasswordData;